import React from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { UIStyleProps } from "./UIComponents";
import { UICMSContent } from "./UICMSContent";
import { ButtonLinkType } from "../../models/cms";
import "./UITextBlock.scss";

type UITextBlockProps = {
	title: string;
	isMainHeading?: boolean;
	iconUrl?: string;
	desc: string;
	link?: {
		url: string;
		display: string;
		internal?: boolean;
		buttonLinkType?: ButtonLinkType;
		buttonMarginLeft?: number;
		xlButton?: boolean;
	};
	children?: React.ReactNode;
	editable?: boolean;
	cmsField?: string;
	onInput?: (e: React.FormEvent<HTMLElement>) => any;
} & UIStyleProps;

export const UITextBlock: React.FC<UITextBlockProps> = (props: UITextBlockProps) => {
	const getLinkDisplay = () => {
		if (!props.link.buttonLinkType) return props.link.display;
		return (
			<button
				type="button"
				className={clsx(
					"btn px-4 mt-1",
					`btn-${props.link.buttonLinkType || "default"}`,
					props.link.buttonMarginLeft ? `ml-${props.link.buttonMarginLeft}-desktop` : "",
					props.link.xlButton && "btn-lg"
				)}
			>
				{props.link.display}
			</button>
		);
	};
	return (
		<div className={clsx("ui-text-block d-flex flex-column flex-md-row align-items-start", props.className)}>
			{!!props.iconUrl && <img className="ui-text-block-icon mr-4 d-none d-md-block" src={props.iconUrl} />}
			<div>
				{props.title && (
					<>
						{props.isMainHeading && (
							<h1
								className={clsx("highlighted", props.editable && "cms-editable-field")}
								contentEditable={props.editable}
								onBlur={props.onInput}
								data-cms-field={`${props.cmsField}.title`}
							>
								{props.title}
							</h1>
						)}
						{!props.isMainHeading && (
							<h2 className="d-flex">
								{!!props.iconUrl && (
									<img
										className="ui-text-block-icon mr-2-5 d-inline-block d-md-none"
										src={props.iconUrl}
									/>
								)}
								<span
									className={clsx(props.editable && "cms-editable-field")}
									contentEditable={props.editable}
									data-cms-field={`${props.cmsField}.title`}
									// onInput={props.onInput}
									onBlur={props.onInput}
								>
									{props.title}
								</span>
							</h2>
						)}
					</>
				)}
				{props.children}
				{!!props.desc && (
					<p className="text-md mt-3">
						<UICMSContent
							content={props.desc}
							editable={props.editable}
							cmsField={`${props.cmsField}.content`}
							onInput={props.onInput}
						/>
					</p>
				)}
				{!!props.link && !!props.link.url && (
					<>
						{!!props.link.internal && (
							<NavLink
								contentEditable={props.editable}
								className={clsx(
									!props.link.buttonLinkType && "with-arrow orange-link mt-0 text-xs text-uppercase",
									props.editable && "cms-editable-field"
								)}
								data-cms-field={`${props.cmsField}.link.display`}
								onBlur={props.onInput}
								to={props.link.url}
								onClick={
									props.editable
										? (e) => {
												e.preventDefault();
												e.stopPropagation();
										  }
										: undefined
								}
							>
								{getLinkDisplay()}
							</NavLink>
						)}
						{!props.link.internal && (
							<a
								className={clsx(
									!props.link.buttonLinkType && "with-arrow orange-link mt-0 text-xs text-uppercase",
									props.editable && "cms-editable-field"
								)}
								href={props.link.url}
								target="_blank"
								contentEditable={props.editable}
								data-cms-field={`${props.cmsField}.link.display`}
								onBlur={props.onInput}
								onClick={
									props.editable
										? (e) => {
												e.preventDefault();
												e.stopPropagation();
										  }
										: undefined
								}
							>
								{getLinkDisplay()}
							</a>
						)}
					</>
				)}
			</div>
		</div>
	);
};
